<template>
    <el-container>
        <el-aside class="app_aside">
            <div class="app_logo">
                <img src="../assets/logo.png" alt="">
            </div>
            <MyAside :asideId="app_asideId"></MyAside>
        </el-aside>
        <el-container>
            <el-header>
                <MyHeader></MyHeader>
            </el-header>
            <div class="app_con">
                <div class="app_Rig app_RigW">
                    <div class="app_TNav">
                        <div class="app_TList">
                          <div class="app_TItem"
                               v-for="(todo, index) in todos"
                               :class="{ app_TAct: activeTabIndex === index }"
                               @click="switchTab(index)">
                            {{todo.title}} <i class="el-icon-close" @click.stop="removeTodo(index)" v-if="index>0"></i>
                          </div>
                        </div>
                    </div>
                    <el-main>
                        <div class="orderTop">
                            <div class="orderTit">
                                <p>发布任务</p>
                                <div class="orderTBtn">
                                    <el-button @click="templatetitlea='';mblist()">快速调用模板</el-button>
                                    <el-button @click='addorder(2)'>保存至模板</el-button>
                                </div>
                            </div>
                            <div class="orderTabs">
                                <el-tabs v-model="activeName" @tab-click="handleTabClick(1)">
                                    <el-tab-pane label="短视频任务" name="first" >
                                        <el-form ref="demandForma" :model="demandForm" label-width="150px"  :rules="usertemplate">
                                        <div class="orderXBox">
                                            <div class="orderXTit">需求描述</div>
                                            <div class="orderFrom">
                                                    <el-form-item label="类型:" class="orderFItem"  prop="xtype">
                                                        <el-select v-model="demandForm.xtype" placeholder="请选择类型">
                                                            <el-option  v-for="item in data.dsp.xcon"
                                                                        :label="item"
                                                                        :value="item"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="需求描述:" class="orderFItem"  prop="xcon">
                                                        <el-input v-model="demandForm.xcon" placeholder="一句话说明您的需求"></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="订单平台:" class="orderFItem"  prop="xcon">
                                                      <el-select v-model="demandForm.order" placeholder="请选择订单平台">
                                                        <el-option  v-for="item in data.ddpt"
                                                                    :label="item.title"
                                                                    :value="item.title"></el-option>
                                                      </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="订单编号:" class="orderFItem"  prop="orderbh">
                                                      <el-input v-model="demandForm.orderbh" placeholder="订单编号"></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="需求说明:" class="orderFItem"  prop="xsm">
                                                        <el-input type="textarea" v-model="demandForm.xsm"
                                                            placeholder="请填写详细需求说明"></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="接单要求:" class="orderFItem" >
                                                        <el-input type="textarea" v-model="demandForm.jdyq" :placeholder="data.rwsm.con" ></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="客户实付金额:" class="orderFItem" prop="sfprice">
                                                      <el-input v-model="demandForm.sfprice"
                                                        placeholder="请输入第三方平台的客户实付金额 "> <template
                                                    slot="append">元</template></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="任务佣金:" class="orderFItem" prop="yjprice">
                                                        <el-input v-model="demandForm.yjprice"
                                                                  placeholder="请填写发布到任务大厅时的任务佣金"><template
                                                                slot="append">元</template></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="保证金:" class="orderFItem" prop="yjprice">
                                                        <el-input v-model="demandForm.bzprice"
                                                                  placeholder="请填写接单人缴纳的保证金。订单完结时全额退还"><template
                                                                slot="append">元</template></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="手续费:" class="orderFItem" prop="yjprice">
                                                        <el-input v-model="demandForm.sjprice"
                                                                  placeholder="请填写手续费"><template
                                                                slot="append">元</template></el-input>
                                                    </el-form-item>

                                              <el-form-item label="交稿时间:" class="orderFItem" prop="jgtime" >
                                                <vue-flatpickr
                                                    v-model="demandForm.jgtime"
                                                    :config="flatpickrConfig"
                                                    placeholder="交稿时间"
                                                    class="el-input__inner">
                                                </vue-flatpickr>
                                              </el-form-item>


                                            </div>
                                        </div>
                                        <div class="orderCBox">
                                            <div class="orderXTit">视频任务要求</div>
                                            <div class="orderFrom">
                                                    <el-form-item label="标签:" class="orderDItem">
                                                      <el-checkbox-group v-model="demandForm.bq">
                                                        <el-checkbox v-for="itema in data.dsp.rcon" :key="itema" :label="itema"
                                                                 >{{ itema}}</el-checkbox>
                                                      </el-checkbox-group>
                                                    </el-form-item>
                                                    <el-form-item label="作品数量:" class="orderFItem" >
                                                        <el-input v-model.number="demandForm.num"
                                                                  @input="num"
                                                                  placeholder="">
                                                            <template slot="append">件</template></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="视频时长:" class="orderFItem orderVTime"  prop="spsca">
                                                        <el-input v-model.number="demandForm.spsca"
                                                                  placeholder=" ">
                                                            <template slot="append">时</template></el-input>
                                                        <el-input v-model.number="demandForm.spscb" placeholder="">
                                                            <template slot="append">分</template></el-input>
                                                        <el-input v-model.number="demandForm.spscc" placeholder="">
                                                            <template slot="append">秒</template></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="尺寸:" class="orderFItem">
                                                        <el-select v-model="demandForm.size" placeholder="请选择尺寸">
                                                            <el-option v-for="item in data.dsp.size"
                                                                       :label="item"
                                                                       :value="item"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="是否提供素材:" class="orderFItem orderDx">
                                                        <el-radio-group v-model="demandForm.sc">
                                                          <el-radio :label="'是'">是</el-radio>
                                                          <el-radio :label="'否'">否</el-radio>
                                                        </el-radio-group>
                                                    </el-form-item>
                                                    <el-form-item label="动画/特效:" class="orderFItem orderDx">
                                                        <el-radio-group v-model="demandForm.tx">
                                                          <el-radio :label="'是'">是</el-radio>
                                                          <el-radio :label="'否'">否</el-radio>
                                                        </el-radio-group>
                                                    </el-form-item>
                                                    <el-form-item label="是否提供脚本:" class="orderFItem orderDx">
                                                        <el-radio-group v-model="demandForm.jb">
                                                          <el-radio :label="'是'">是</el-radio>
                                                          <el-radio :label="'否'">否</el-radio>
                                                        </el-radio-group>
                                                    </el-form-item>
                                                    <el-form-item label="文件上传:" class="orderFItem orderSc">

                                                      <el-upload
                                                          class="upload-demo"
                                                          action="/?a=add_file&action=ok&name=file"
                                                          :on-remove="handleRemove"
                                                          :file-list="fileList"
                                                          :on-success="handleSuccess"
                                                      >
                                                      <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
                                                      </el-upload>
                                                    </el-form-item>
                                            </div>
                                        </div>
                                        <div class="orderCBox">
                                            <div class="orderXTit">联系方式</div>
                                            <div class="orderFrom">
                                                    <el-form-item label="联系人姓名:" class="orderFItem" prop="xm">
                                                        <el-input v-model="demandForm.xm"  >
                                                            <template slot="append"> <i class="el-icon-close"></i></template></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="联系手机:" class="orderFItem" prop="tel">
                                                        <el-input v-model="demandForm.tel" >
                                                            <template slot="append"> <i class="el-icon-close"></i></template></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="联系微信:" class="orderFItem">
                                                        <el-input v-model="demandForm.lxtel" placeholder="" >
                                                            <template slot="append"> <i class="el-icon-close"></i></template></el-input>
                                                    </el-form-item>
                                            </div>
                                        </div>
                                        <div class="orderBon">
                                            <el-button icon="el-icon-document-checked" @click="addorder(1)">保存</el-button>
                                            <el-button icon="el-icon-upload2" @click="addorder(3)">发布</el-button>
                                            <el-button icon="el-icon-position" @click="addorder(2)">保存至模板</el-button>
                                        </div>
                                        </el-form>
                                    </el-tab-pane>
                                    <el-tab-pane label="图片处理任务" name="second">
                                      <el-form ref="demandForma" :model="demandForm" label-width="150px"  :rules="usertemplate">
                                        <div class="orderXBox">
                                          <div class="orderXTit">需求描述</div>
                                          <div class="orderFrom">
                                            <el-form-item label="类型:" class="orderFItem"  prop="xtype">
                                              <el-select v-model="demandForm.xtype" placeholder="请选择类型">
                                                <el-option  v-for="item in data.tp.xcon"
                                                            :label="item"
                                                            :value="item"></el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item label="需求描述:" class="orderFItem"  prop="xcon">
                                              <el-input v-model="demandForm.xcon" placeholder="一句话说明您的需求"></el-input>
                                            </el-form-item>
                                            <el-form-item label="订单平台:" class="orderFItem"  prop="xcon">
                                              <el-select v-model="demandForm.order" placeholder="请选择订单平台">
                                                <el-option  v-for="item in data.ddpt"
                                                            :label="item.title"
                                                            :value="item.title"></el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item label="订单编号:" class="orderFItem"  prop="orderbh">
                                              <el-input v-model="demandForm.orderbh" placeholder="订单编号"></el-input>
                                            </el-form-item>
                                            <el-form-item label="需求说明:" class="orderFItem"  prop="xsm">
                                              <el-input type="textarea" v-model="demandForm.xsm"
                                                        placeholder="请填写详细需求说明"></el-input>
                                            </el-form-item>
                                            <el-form-item label="接单要求:" class="orderFItem" >
                                              <el-input type="textarea" v-model="demandForm.jdyq" :placeholder="data.rwsm.con" ></el-input>
                                            </el-form-item>
                                            <el-form-item label="客户实付金额:" class="orderFItem" prop="sfprice">
                                              <el-input v-model="demandForm.sfprice"
                                                        placeholder="请输入第三方平台的客户实付金额 "> <template
                                                  slot="append">元</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="任务佣金:" class="orderFItem" prop="yjprice" >
                                              <el-input v-model="demandForm.yjprice"
                                                        placeholder="请填写发布到任务大厅时的任务佣金"><template
                                                  slot="append">元</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="保证金:" class="orderFItem" prop="yjprice" >
                                              <el-input v-model="demandForm.bzprice"
                                                        placeholder="请填写接单人缴纳的保证金。订单完结时全额退还"><template
                                                  slot="append">元</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="手续费:" class="orderFItem" prop="yjprice" >
                                              <el-input v-model="demandForm.sjprice"
                                                        placeholder="请填写手续费"><template
                                                  slot="append">元</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="交稿时间:" class="orderFItem" prop="jgtime" >
                                              <vue-flatpickr
                                                  v-model="demandForm.jgtime"
                                                  :config="flatpickrConfig"
                                                  placeholder="交稿时间"
                                                  class="el-input__inner">
                                              </vue-flatpickr>
                                            </el-form-item>

                                          </div>
                                        </div>
                                        <div class="orderCBox">
                                          <div class="orderXTit">图片处理任务要求</div>
                                          <div class="orderFrom">
                                            <el-form-item label="标签:" class="orderDItem">
                                              <el-checkbox-group v-model="demandForm.bq">
                                                <el-checkbox v-for="itema in data.tp.rcon" :key="itema" :label="itema"
                                                >{{ itema}}</el-checkbox>
                                              </el-checkbox-group>
                                            </el-form-item>
                                            <el-form-item label="作品数量:" class="orderFItem"  prop="num">
                                              <el-input v-model.number="demandForm.num"
                                                        @input="num"
                                                        placeholder="">
                                                <template slot="append">件</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="排版要求:" class="orderFItem" >
                                              <el-select v-model="demandForm.spsc" placeholder="排版要求">
                                                <el-option  v-for="item in data.tp.size"
                                                            :label="item"
                                                            :value="item"></el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item label="尺寸:" class="orderFItem"  prop="num">
                                              <el-input v-model="demandForm.size" placeholder="">
                                               </el-input>
                                            </el-form-item>
                                            <el-form-item label="分辨率:" class="orderFItem" >
                                              <el-select v-model="demandForm.pp" placeholder="排版要求">
                                                <el-option  v-for="item in data.tp.ppyq"
                                                            :label="item"
                                                            :value="item"></el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item label="是否提供素材:" class="orderFItem orderDx">
                                              <el-radio-group v-model="demandForm.sc">
                                                <el-radio :label="'是'">是</el-radio>
                                                <el-radio :label="'否'">否</el-radio>
                                              </el-radio-group>
                                            </el-form-item>

                                            <el-form-item label="文件上传:" class="orderFItem orderSc">

                                              <el-upload
                                                  class="upload-demo"
                                                  action="/?a=add_file&action=ok&name=file"
                                                  :on-remove="handleRemove"
                                                  :file-list="fileList"
                                                  :on-success="handleSuccess"
                                              >
                                                <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
                                              </el-upload>
                                            </el-form-item>
                                          </div>
                                        </div>
                                        <div class="orderCBox">
                                          <div class="orderXTit">联系方式</div>
                                          <div class="orderFrom">
                                            <el-form-item label="名称:" class="orderFItem" prop="xm">
                                              <el-input v-model="demandForm.xm"  >
                                                <template slot="append"> <i class="el-icon-close"></i></template></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系手机:" class="orderFItem" prop="tel">
                                              <el-input v-model="demandForm.tel" >
                                                <template slot="append"> <i class="el-icon-close"></i></template></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系微信:" class="orderFItem">
                                              <el-input v-model="demandForm.lxtel" placeholder="" >
                                                <template slot="append"> <i class="el-icon-close"></i></template></el-input>
                                            </el-form-item>
                                          </div>
                                        </div>
                                        <div class="orderBon">
                                          <el-button icon="el-icon-document-checked" @click="addorder(1)">保存</el-button>
                                          <el-button icon="el-icon-upload2" @click="addorder(3)">发布</el-button>
                                          <el-button icon="el-icon-position" @click="addorder(2)">保存至模板</el-button>
                                        </div>
                                      </el-form>
                                    </el-tab-pane>
                                    <el-tab-pane label="PPT任务" name="third">
                                      <el-form ref="demandForma" :model="demandForm" label-width="150px"  :rules="usertemplate">
                                        <div class="orderXBox">
                                          <div class="orderXTit">需求描述</div>
                                          <div class="orderFrom">
                                            <el-form-item label="类型:" class="orderFItem"  prop="xtype">
                                              <el-select v-model="demandForm.xtype" placeholder="请选择类型">
                                                <el-option  v-for="item in data.ppt.xcon"
                                                            :label="item"
                                                            :value="item"></el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item label="需求描述:" class="orderFItem"  prop="xcon">
                                              <el-input v-model="demandForm.xcon" placeholder="一句话说明您的需求"></el-input>
                                            </el-form-item>
                                            <el-form-item label="订单平台:" class="orderFItem"  prop="xcon">
                                              <el-select v-model="demandForm.order" placeholder="请选择订单平台">
                                                <el-option  v-for="item in data.ddpt"
                                                            :label="item.title"
                                                            :value="item.title"></el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item label="订单编号:" class="orderFItem"  prop="orderbh">
                                              <el-input v-model="demandForm.orderbh" placeholder="订单编号"></el-input>
                                            </el-form-item>
                                            <el-form-item label="需求说明:" class="orderFItem"  prop="xsm">
                                              <el-input type="textarea" v-model="demandForm.xsm"
                                                        placeholder="请填写详细需求说明"></el-input>
                                            </el-form-item>
                                            <el-form-item label="接单要求:" class="orderFItem" >
                                              <el-input type="textarea" v-model="demandForm.jdyq" :placeholder="data.rwsm.con" ></el-input>
                                            </el-form-item>
                                            <el-form-item label="客户实付金额:" class="orderFItem" prop="sfprice">
                                              <el-input v-model="demandForm.sfprice"
                                                        placeholder="请输入第三方平台的客户实付金额 "> <template
                                                  slot="append">元</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="任务佣金:" class="orderFItem" prop="yjprice" >
                                              <el-input v-model="demandForm.yjprice"
                                                        placeholder="请填写发布到任务大厅时的任务佣金"><template
                                                  slot="append">元</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="保证金:" class="orderFItem" prop="yjprice" >
                                              <el-input v-model="demandForm.bzprice"
                                                        placeholder="请填写接单人缴纳的保证金。订单完结时全额退还"><template
                                                  slot="append">元</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="手续费:" class="orderFItem" prop="yjprice" >
                                              <el-input v-model="demandForm.sjprice"
                                                        placeholder="请填写手续费"><template
                                                  slot="append">元</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="交稿时间:" class="orderFItem" prop="jgtime" >
                                              <vue-flatpickr
                                                  v-model="demandForm.jgtime"
                                                  :config="flatpickrConfig"
                                                  placeholder="交稿时间"
                                                  class="el-input__inner">
                                              </vue-flatpickr>
                                            </el-form-item>

                                          </div>
                                        </div>
                                        <div class="orderCBox">
                                          <div class="orderXTit">PPT任务要求</div>
                                          <div class="orderFrom">
                                            <el-form-item label="标签:" class="orderDItem">
                                              <el-checkbox-group v-model="demandForm.bq">
                                                <el-checkbox v-for="itema in data.ppt.rcon" :key="itema" :label="itema"
                                                >{{ itema}}</el-checkbox>
                                              </el-checkbox-group>
                                            </el-form-item>
                                            <el-form-item label="页数:" class="orderFItem" >
                                              <el-input v-model.number="demandForm.num"
                                                        @input="num"
                                                        placeholder="">
                                                <template slot="append">页</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="比例:" class="orderFItem" >
                                              <el-select v-model="demandForm.spsc" placeholder="比例">
                                                <el-option  v-for="item in data.tp.ppyq"
                                                            :label="item"
                                                            :value="item"></el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item label="文件格式要求:" class="orderFItem" >
                                              <el-select v-model="demandForm.pp" placeholder="文件格式要求">
                                                <el-option  v-for="item in data.ppt.size"
                                                            :label="item"
                                                            :value="item"></el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item label="场合:" class="orderFItem" >
                                              <el-input v-model.number="demandForm.fbl" placeholder="请输入场合">
                                               </el-input>
                                            </el-form-item>
                                            <el-form-item label="文件上传:" class="orderFItem orderSc">

                                              <el-upload
                                                  class="upload-demo"
                                                  action="/?a=add_file&action=ok&name=file"
                                                  :on-remove="handleRemove"
                                                  :file-list="fileList"
                                                  :on-success="handleSuccess"
                                              >
                                                <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
                                              </el-upload>
                                            </el-form-item>
                                          </div>
                                        </div>
                                        <div class="orderCBox">
                                          <div class="orderXTit">联系方式</div>
                                          <div class="orderFrom">
                                            <el-form-item label="名称:" class="orderFItem" prop="xm">
                                              <el-input v-model="demandForm.xm"  >
                                                <template slot="append"> <i class="el-icon-close"></i></template></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系手机:" class="orderFItem" prop="tel">
                                              <el-input v-model="demandForm.tel" >
                                                <template slot="append"> <i class="el-icon-close"></i></template></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系微信:" class="orderFItem">
                                              <el-input v-model="demandForm.lxtel" placeholder="" >
                                                <template slot="append"> <i class="el-icon-close"></i></template></el-input>
                                            </el-form-item>
                                          </div>
                                        </div>
                                        <div class="orderBon">
                                          <el-button icon="el-icon-document-checked" @click="addorder(1)">保存</el-button>
                                          <el-button icon="el-icon-upload2" @click="addorder(3)">发布</el-button>
                                          <el-button icon="el-icon-position" @click="addorder(2)">保存至模板</el-button>
                                        </div>
                                      </el-form>
                                    </el-tab-pane>
                                    <el-tab-pane label="CAD效果图任务" name="fourth">
                                      <el-form ref="demandForma" :model="demandForm" label-width="150px"  :rules="usertemplate">
                                        <div class="orderXBox">
                                          <div class="orderXTit">需求描述</div>
                                          <div class="orderFrom">
                                            <el-form-item label="类型:" class="orderFItem"  prop="xtype">
                                              <el-select v-model="demandForm.xtype" placeholder="请选择类型">
                                                <el-option  v-for="item in data.cad.xcon"
                                                            :label="item"
                                                            :value="item"></el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item label="需求描述:" class="orderFItem"  prop="xcon">
                                              <el-input v-model="demandForm.xcon" placeholder="一句话说明您的需求"></el-input>
                                            </el-form-item>
                                            <el-form-item label="订单平台:" class="orderFItem"  prop="xcon">
                                              <el-select v-model="demandForm.order" placeholder="请选择订单平台">
                                                <el-option  v-for="item in data.ddpt"
                                                            :label="item.title"
                                                            :value="item.title"></el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item label="订单编号:" class="orderFItem"  prop="orderbh">
                                              <el-input v-model="demandForm.orderbh" placeholder="订单编号"></el-input>
                                            </el-form-item>
                                            <el-form-item label="需求说明:" class="orderFItem"  prop="xsm">
                                              <el-input type="textarea" v-model="demandForm.xsm"
                                                        placeholder="请填写详细需求说明"></el-input>
                                            </el-form-item>
                                            <el-form-item label="接单要求:" class="orderFItem" >
                                              <el-input type="textarea" v-model="demandForm.jdyq" :placeholder="data.rwsm.con" ></el-input>
                                            </el-form-item>
                                            <el-form-item label="客户实付金额:" class="orderFItem" prop="sfprice">
                                              <el-input v-model="demandForm.sfprice"
                                                        placeholder="请输入第三方平台的客户实付金额 "> <template
                                                  slot="append">元</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="任务佣金:" class="orderFItem" prop="yjprice">
                                              <el-input v-model="demandForm.yjprice"
                                                        placeholder="请填写发布到任务大厅时的任务佣金"><template
                                                  slot="append">元</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="保证金:" class="orderFItem"  prop="yjprice">
                                              <el-input v-model="demandForm.bzprice"
                                                        placeholder="请填写接单人缴纳的保证金。订单完结时全额退还"><template
                                                  slot="append">元</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="手续费:" class="orderFItem"  prop="yjprice">
                                              <el-input v-model="demandForm.sjprice"
                                                        placeholder="请填写手续费"><template
                                                  slot="append">元</template></el-input>
                                            </el-form-item>
                                            <el-form-item label="交稿时间:" class="orderFItem" prop="jgtime" >
                                              <vue-flatpickr
                                                  v-model="demandForm.jgtime"
                                                  :config="flatpickrConfig"
                                                  placeholder="交稿时间"
                                                  class="el-input__inner">
                                              </vue-flatpickr>
                                            </el-form-item>
                                          </div>
                                        </div>
                                        <div class="orderCBox">
                                          <div class="orderXTit">联系方式</div>
                                          <div class="orderFrom">
                                            <el-form-item label="名称:" class="orderFItem" prop="xm">
                                              <el-input v-model="demandForm.xm"  >
                                                <template slot="append"> <i class="el-icon-close"></i></template></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系手机:" class="orderFItem" prop="tel">
                                              <el-input v-model="demandForm.tel" >
                                                <template slot="append"> <i class="el-icon-close"></i></template></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系微信:" class="orderFItem">
                                              <el-input v-model="demandForm.lxtel" placeholder="" >
                                                <template slot="append"> <i class="el-icon-close"></i></template></el-input>
                                            </el-form-item>
                                          </div>
                                        </div>
                                        <div class="orderBon">
                                          <el-button icon="el-icon-document-checked" @click="addorder(1)">保存</el-button>
                                          <el-button icon="el-icon-upload2" @click="addorder(3)">发布</el-button>
                                          <el-button icon="el-icon-position" @click="addorder(2)">保存至模板</el-button>
                                        </div>
                                      </el-form>
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                        </div>
                        <div style="height: 60px;"></div>
                        <el-dialog title="模板选择" class="templateBox" :visible.sync="templateShow">
                            <el-form :model="templateForm" label-width="100px">
                                <el-form-item label="模板名称">
                                    <el-input v-model="templatetitlea" autocomplete="off" placeholder="请输入模板名称"></el-input>
                                </el-form-item>
                                <div class="taskFBon">
                                        <el-button icon="el-icon-refresh" @click="templatetitlea='';mblist()">重置</el-button>
                                  <el-button
                                            icon="el-icon-search" @click="mblist()" >搜索</el-button>
                                    </div>
                            </el-form>
                            <div class="tempTable">
                                <el-table :data="templateData" border="1">
                                  <el-table-column width="55">
                                    <template v-slot="scope">
                                      <el-radio
                                          v-model="selectedRowKey"
                                          :label="scope.$index"
                                      >{{value1}}</el-radio>
                                    </template>
                                  </el-table-column>
                                  <el-table-column prop="num" label="序号" width="80">
                                    </el-table-column>
                                    <el-table-column prop="type" label="业务类型" width="200">
                                    </el-table-column>
                                    <el-table-column prop="title" label="模板名称" min-width="250">
                                    </el-table-column>
                                </el-table>
                                <div class="app_page">
                                    <el-pagination
                                        @size-change="sizechange"
                                        @current-change="handleCurrentChange"
                            layout="sizes, prev, pager, next" 
                            :page-sizes="[10,50,80,100]" :page-size="10" :total="pagesize" :current-page="onpage">
                        </el-pagination>
                    </div>
                            </div>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="templateShow = false;selectedRowKey=''" class="Password_hide">取 消</el-button>
                                <el-button type="primary" @click="thismb">确 定</el-button>
                            </div>
                        </el-dialog>
                        <el-dialog title="模板名称" class="templateBox" :visible.sync="templatetitleShow">
                          <el-form  label-width="100px">
                          <el-form-item label="模板名称">
                            <el-input v-model="templatetitle" autocomplete="off" placeholder="请输入模板名称"></el-input>
                          </el-form-item>
                        </el-form>
                          <div slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="addorder(2)">确 定</el-button>
                            <el-button @click="templatetitleShow = false" class="Password_hide">取 消</el-button>
                          </div>
                        </el-dialog>
                    </el-main>
                </div>
            </div>
        </el-container>
    </el-container>
</template>

<script>
import axios from "axios";
import VueFlatpickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/l10n/zh.js';
export default {
    name: 'order',
    components: {
      VueFlatpickr
    },
    data() {
        return {
          templatetitlea:'',
          flatpickrConfig: {
            allowInput: false,
            enableTime: true,
            dateFormat: 'Y-m-d H:i',
            time_24hr: true,
            minDate: "today", // 设置只能选择今天之后的日期
            locale: 'zh' // 使用中文
          },
          usertemplate:{
              xtype: [
                { required: true, message: '请选择类型', trigger: 'change' }
              ],
              xcon: [
                { required: true, message: '请输入需求描述', trigger: 'blur' }
              ],
            orderbh: [
                { required: true, message: '请输入订单编号', trigger: 'blur' }
              ],
              xsm: [
                { required: true, message: '请输入需求说明', trigger: 'blur' }
              ],
              sfprice: [
                { required: true, message: '请输入实付金额', trigger: 'blur' }
              ],
              yjprice: [
                { required: true, message: '', trigger: 'blur' }
              ],
              bzprice: [
                { required: true, message: '请输入保障金', trigger: 'blur' }
              ],
              num: [
                { required: true, message: '作品数量', trigger: 'blur' }
              ],
              spsca: [
                { required: true, message: '请输入视频时长', trigger: 'blur' }
              ],
              xm: [
                { required: true, message: '请输入联系姓名', trigger: 'blur' }
              ],
              tel: [
                { required: true, message: '请输入联系手机号码', trigger: 'blur' }
              ],
              jgtime: [
                { required: true, message: '请选择交稿时间', trigger: 'blur' }
              ],

          },
            asideId: 2,
            selectedRowKey:"",
            value1: '',
            on_orderId: 1,
            orderid:0,
            app_asideId: 2,
            activeName: 'first',
            activeTabIndex:0,
            demandForm: {
              bq:[],
              sc:'否',
              tx:'否',
              jb:'否',
              xtype:'',
              xcon: '',
              xsm: '',
              yjprice: '',
              bzprice: '',
              num: '',
              spsc:'',
              xm: '',
              tel: '',
              lxtel: '',
            },
            checkboxGroup: [],
            contactForm:[],
            templateForm:{
                name:''
            },
            templateShow:false,
            templatetitleShow:false,
            templatetitle:'',
            templateData:[],
          todos:[],
          data:[],
          fileList:[],
          onpage:0,
          pagesize:0,
          userpath:0
        }
    },
    beforeRouteLeave(to, from, next) {
      console.log(this.$route.name)
      this.$store.commit('savePageState', {
        pageName: "Publish_task",
        pageState: {
          activeName: this.activeName,
          demandForm: this.demandForm,
          data: this.data,
        }
      });
      next();
    },
    // 这里为了测试被切换的组件去哪了
    mounted() {
        this.todos=this.$store.state.tags
        let todos= this.todos
        console.log('111');
        let index =todos.findIndex(note => note.path === "Publish_task");
        if(index>=0){
          this.activeTabIndex=index
        }else{
          const newNote = {
            title: "发布任务",
            path: 'Publish_task'
          }
          this.$store.state.tags.push(newNote);
          this.activeTabIndex=this.todos.length - 1
        }
      this.fetchTableData();
      this.userpath=this.$store.state.userpath
      let savedState = this.$store.state.pageState["Publish_task"];
      console.log(savedState)
      if (savedState) {
        this.activeName=savedState.activeName
        this.demandForm=savedState.demandForm
        this.data=savedState.data
        console.log(this.data)
        // this.handleTabClick(0)
      }
    },
    methods: {
      handleTabClick(tab) {
        if(tab==0){
          console.log(this.demandForm)
        }
        this.demandForm.bq=[]; // 重置表单
        this.demandForm.xtype=[]; // 重置表单
      },
      yjprice(value){
          // 清理非数字字符（除了点号用于小数）
          const cleanedValue = value.replace(/[^\d.]/g, '');
          if (!cleanedValue || cleanedValue === '.') {
            this.demandForm.yjprice = 0; // 或者你想要的默认值
            return;
          }
          console.log(333)
          // 确保只有一个小数点
          const parts = cleanedValue.split('.');
          const mainPart = parts[0];
          const decimalPart = parts[1] ? parts[1].slice(0, 2) : ''; // 限制小数位数为两位
          const formattedValue = `${mainPart}.${decimalPart}`;
          if (formattedValue !== value) {
            this.demandForm.yjprice = parseFloat(formattedValue);
            this.demandForm.yjprice = parseFloat(formattedValue*this.data.yjset.price).toFixed(2);
          }
        },
        bzprice(value){
          // 清理非数字字符（除了点号用于小数）
          const cleanedValue = value.replace(/[^\d.]/g, '');
          if (!cleanedValue || cleanedValue === '.') {
            this.demandForm.bzprice = 0; // 或者你想要的默认值
            return;
          }
          // 确保只有一个小数点
          const parts = cleanedValue.split('.');
          const mainPart = parts[0];
          const decimalPart = parts[1] ? parts[1].slice(0, 2) : ''; // 限制小数位数为两位
          const formattedValue = `${mainPart}.${decimalPart}`;
          if (formattedValue !== value) {
            this.demandForm.bzprice = parseFloat(formattedValue);
          }
        },
        sfprice(value){
          console.log(this.data.yjset)
          // 清理非数字字符（除了点号用于小数）
          const cleanedValue = value.replace(/[^\d.]/g, '');
          if (!cleanedValue || cleanedValue === '.') {
            this.demandForm.sfprice = 0; // 或者你想要的默认值
            return;
          }
          // 确保只有一个小数点
          const parts = cleanedValue.split('.');
          const mainPart = parts[0];
          const decimalPart = parts[1] ? parts[1].slice(0, 2) : ''; // 限制小数位数为两位
          const formattedValue = `${mainPart}.${decimalPart}`;
          this.data.yjset.price=this.data.yjset.price>0?this.data.yjset.price:this.data.yjset.title
          this.data.yjset.sjprice=this.data.yjset.sjprice>0?this.data.yjset.sjprice:this.data.yjset.title
          if (formattedValue !== value) {
            this.demandForm.sfprice = Math.round(parseFloat(formattedValue));
            this.demandForm.yjprice = Math.round(parseFloat(formattedValue) * this.data.yjset.title);
            this.demandForm.bzprice = Math.round(parseFloat(this.demandForm.yjprice) * this.data.yjset.price);
            this.demandForm.sjprice = Math.round(parseFloat(this.demandForm.yjprice) * this.data.yjset.sjprice);
          }
        },
        num(value){
          // 清理非数字字符（除了点号用于小数）
          const cleanedValue = value.replace(/[^\d.]/g, '');
          if (!cleanedValue || cleanedValue === '.') {
            this.demandForm.num = 0; // 或者你想要的默认值
            return;
          }
          const parts = cleanedValue.split('.');
          const mainPart = parts[0];
          let decimalPart = parts[1] ? parts[1].slice(0, 2) : ''; // 限制小数位数为两位
          if (decimalPart === '00' || !decimalPart) {
            decimalPart = '';
          }
          const formattedValue = `${mainPart}${decimalPart ? `.${decimalPart}` : ''}`;
          const numericValue = parseFloat(formattedValue);
          if (decimalPart === '') {
            this.demandForm.num = Math.floor(numericValue); // 或者使用 parseInt(numericValue, 10)
          } else {
            this.demandForm.num = numericValue;
          }
        },
        switchTab(index) {
          this.$router.push(this.todos[index].path); // 使用push保留历史记录，或使用replace不保留
        },
        removeTodo(index) {
          this.todos.splice(index, 1);
          this.$forceUpdate();
          if(index==this.activeTabIndex){
            this.$router.push(this.todos[index].path);
          }else if(index<this.activeTabIndex){
            this.activeTabIndex=this.activeTabIndex-1
          }
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        fetchTableData() {
          console.log(123)
          axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=publish_task')
              .then(response => {
                  this.data = response.data;
                this.demandForm.xm=response.data.user.xm
                this.demandForm.tel=response.data.user.title
                this.demandForm.lxtel=response.data.user.wx
                console.log(this.data.dsp.rcon)
              })
              .catch(error => {
                // 处理错误情况
                console.error("There was an error!", error);
              });

        },
        handleRemove(file, fileList) {
          console.log(fileList)
          console.log(this.fileList)
          console.log('remove', file, fileList);
          this.demandForm.file='';
        },
        handleSuccess(response, file, fileList) {
          console.log(fileList)
          console.log(this.fileList)
          console.log('success', response, file, fileList);
          this.demandForm.file=fileList;
          console.log(this.demandForm.file)
          // 这里可以根据你的需求处理上传成功后的逻辑
          // 例如，你可能想要清空 fileList 或更新 Addform 中的某些字段
        },
        on_order(e) {
            console.log('e', e)
            this.on_orderId = e
            if (e == 1) {
                this.$router.push('/Publish_task')
            } else if (e == 2) {
                this.$router.push('/tasklist')
            } else if (e == 3) {
                this.$router.push('/order')
            } else if (e == 4) {
                this.$router.push('/consumer')
            }else if (e == 5) {
                this.$router.push('/endorder')
            }
        },
        addorder(e){
          if(!this.demandForm.xtype){
            this.$message({
              type: 'info',
              message: '请选择类型'
            });
            return false
          }
          if(!this.demandForm.xcon){
            this.$message({
              type: 'info',
              message: '请输入需求描述'
            });
            return false
          }
          if(!this.demandForm.order){
            this.$message({
              type: 'info',
              message: '请选择订单平台'
            });
            return false
          }
          if(!this.demandForm.orderbh){
            this.$message({
              type: 'info',
              message: '请输入订单编号'
            });
            return false
          }
          if(!this.demandForm.xsm){
            this.$message({
              type: 'info',
              message: '请输入需求说明'
            });
            return false
          }
          if(!this.demandForm.sfprice){
            this.$message({
              type: 'info',
              message: '请输入客户实付金额'
            });
            return false
          }
          if(!this.demandForm.yjprice){
            this.$message({
              type: 'info',
              message: '请输入任务佣金'
            });
            return false
          }
          if(!this.demandForm.bzprice){
            this.$message({
              type: 'info',
              message: '请输入保证金'
            });
            return false
          }
          if(!this.demandForm.sjprice){
            this.$message({
              type: 'info',
              message: '请输入手续费'
            });
            return false
          }
          if(!this.demandForm.jgtime){
            this.$message({
              type: 'info',
              message: '请选择交稿时限'
            });
            return false
          }
          if(this.activeName=='first'){
            if(!this.demandForm.spsca&&!this.demandForm.spscb&&!this.demandForm.spscc){
              this.$message({
                type: 'info',
                message: '请输入视频时长'
              });
              return false
            }
          }
          if(this.activeName=='second'){
            if(!this.demandForm.num){
              this.$message({
                type: 'info',
                message: '请输入作品数量'
              });
              return false
            }
            if(!this.demandForm.size){
              this.$message({
                type: 'info',
                message: '请输入尺寸'
              });
              return false
            }
          }
          if(!this.demandForm.xm){
            this.$message({
              type: 'info',
              message: '请输入联系名称'
            });
            return false
          }
          if(!this.demandForm.tel){
            this.$message({
              type: 'info',
              message: '请输入联系手机号码'
            });
            return false
          }
          if(e==2&&this.templatetitleShow==false&&this.templatetitle==''){
            this.templatetitleShow=true;
            return false
          }
          this.demandForm.lx=e
          this.demandForm.type=this.activeName
          this.demandForm.title=this.templatetitle
          if(e==2&&this.templatetitle==''){
            this.$message({
              type: 'info',
              message: "请输入模版名称"
            });
          }
          if(this.orderid>0&&e==1){
            this.demandForm.orderid=this.orderid
          }
          const formData = {
            ...this.demandForm // 使用展开运算符来复制this.demandForm的所有属性
          };
          axios.post(this.$store.state.apiUrl+'/?a=ajax_add&m=order', formData, {
            headers: {
              'Content-Type': 'application/json' // 设置请求头为JSON
            }
          })
              .then(response => {
                const data=response.data
                if(data.status==1){
                  this.$message({
                    type: 'success',
                    message: '操作成功'
                  });
                  if(e==1){
                    this.orderid=data.id
                  }
                  if(e==3){
                    this.demandForm={
                      bq:[],
                      sc:'否',
                      tx:'否',
                      jb:'否',
                      xtype:'',
                      xcon: '',
                      xsm: '',
                      yjprice: '',
                      bzprice: '',
                      num: '',
                      spsc:'',
                      xm: '',
                      tel: '',
                      lxtel: '',
                    }
                    this.$router.push('/order')
                  }
                  this.templatetitleShow = false
                  this.templatetitle = ''
                }else{
                  this.$message({
                    type: 'info',
                    message: data.msg
                  });
                }
              })
              .catch(error => {
                // 处理错误情况
                console.error("There was an error!", error);
              });
        },
        mblist(){
          this.templateShow = true
          this.templateData.title = this.templatetitlea
          const formDataa = {
            ...this.templateData // 使用展开运算符来复制this.demandForm的所有属性
          };
          axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=mb', formDataa, {
            headers: {
              'Content-Type': 'application/json' // 设置请求头为JSON
            }
          })
              .then(response => {
                const data=response.data
                if(data.status==1){
                  this.templateData=data.arr
                  this.pagesize=data.pagesize
                  this.templateShow = true
                }else{
                  this.$message({
                    type: 'info',
                    message: data.msg
                  });
                }
              })
              .catch(error => {
                // 处理错误情况
                console.error("There was an error!", error);
              });
        },
        sizechange(val){
          this.templateData.size = val
          this.templateData.page = 0
          const formDataa = {
            ...this.templateData // 使用展开运算符来复制this.demandForm的所有属性
          };
          axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=mb', formDataa, {
            headers: {
              'Content-Type': 'application/json' // 设置请求头为JSON
            }
          })
              .then(response => {
                const data=response.data
                if(data.status==1){
                  this.templateData=data.arr
                  this.pagesize=data.pagesize
                  this.templateShow = true
                }else{
                  this.$message({
                    type: 'info',
                    message: data.msg
                  });
                }
              })
              .catch(error => {
                // 处理错误情况
                console.error("There was an error!", error);
              });
        },
        handleCurrentChange(val){
          this.templateData.page = val
          const formDataa = {
            ...this.templateData // 使用展开运算符来复制this.demandForm的所有属性
          };
          axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=mb', formDataa, {
            headers: {
              'Content-Type': 'application/json' // 设置请求头为JSON
            }
          })
              .then(response => {
                const data=response.data
                if(data.status==1){
                  this.templateData=data.arr
                  this.pagesize=data.pagesize
                  this.templateShow = true
                }else{
                  this.$message({
                    type: 'info',
                    message: data.msg
                  });
                }
              })
              .catch(error => {
                // 处理错误情况
                console.error("There was an error!", error);
              });
        },
        thismb(){
            console.log(this.templateData[this.selectedRowKey])
            this.activeName=this.templateData[this.selectedRowKey].typea
            this.demandForm=this.templateData[this.selectedRowKey]
            this.selectedRowKey='';
            this.templateShow=false
        }
    },
}
</script>

<style>
.orderFItem .orderFTime{
  width: 100%;
  height: 100%;
  border: none;
  padding: 0 20px;
  font-size: 16px;
}
.orderFItem .orderFTime:focus-visible{
  outline: none;
}
.orderTop {
    padding: 20px;
    background: #fff;
    border-radius: 16px;
}

.orderTit {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.orderTit P {
    font-size: 20px;
    font-weight: 600;
}

.orderTBtn {
    display: flex;
    align-items: center;
}

.orderTabs {
    margin-top: 15px;
}

.orderTabs .el-tabs__item:hover {
    color: #FF5000;
}

.orderTabs .el-tabs__item.is-active {
    color: #FF5000;
}

.orderTabs .el-tabs__active-bar {
    background: #FF5000
}

.orderXBox {
    margin-top: 20px;
    padding: 20px;
    background: #f7f8f9;
    border-radius: 16px;
}

.orderXTit {
    /* padding: 20px; */
    font-size: 18px;
    font-weight: 600;
    display: flex;
    /* justify-content: space-between; */
}

.orderFrom {
    margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
}

.orderFrom .el-form {
    display: flex;
    flex-wrap: wrap;
}

.orderFItem {
    width: 47%;
    margin-right: 3%;
}

.el-select {
    width: 100%;
}

.taskCTable .el-input__inner {
    border: 1px solid #DCDFE6 !important;
}

.el-input__inner {
    border: none !important;
}
.el-textarea__inner:hover {
    border: none !important;
}

.el-textarea__inner {
    border: none !important;
}

.orderFItem .el-textarea__inner {
    width: 100%;
    height: 200px;
    padding: 15px 20px;
    font-size: 14px;
    line-height: 24px;
}

.orderFItem .el-form-item__label {
    font-size: 14px;
}

.el-input__inner {
    font-size: 14px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.orderFItem .el-input-group__append,
.orderFItem .el-input-group__prepend {
    background: #f7f8f9 !important;
    border: none;
    border-left: 1px solid rgb(0, 0, 0, .1);
    font-size: 14px;
    padding: 0 15px;
}

.orderFItem .el-input__prefix {
    position: absolute;
    right: 5px;
    left: auto;
}

.orderFItem .el-date-editor.el-input,
.orderFItem .el-date-editor.el-input__inner {
    width: 100%;
}

.orderFItem .el-input--prefix .el-input__inner {
    padding-left: 15px;
    width: 100%;
}

.el-date-table td span {
    font-size: 14px;
}

.el-picker-panel__footer .el-button:nth-child(1) {
    background: #fff !important;
}

.el-picker-panel__footer .el-button:nth-child(1) span {
    color: #333;
}

.orderFItem .el-form-item__content {
    border-radius: 6px;
    /*overflow: hidden;*/
    top: 5px;
    border: 1px solid rgb(0, 0, 0, .1);
}

.orderCBox {
    margin-top: 20px;
    padding: 20px;
    background: #f7f8f9;
    border-radius: 16px;
}

.orderDItem {
    width: 100%;
}

.el-checkbox-button.is-checked .el-checkbox-button__inner {
    background-color: #FF5000 !important;
    border-color: #FF5000 !important;
    color: #fff !important;
}

.el-checkbox-button__inner:hover {
    color: #FF5000 !important;
}

.el-checkbox-button__inner {
    border: 1px solid rgb(0, 0, 0, .1) !important;
    border-radius: 8px !important;
}

.el-checkbox-button,
.el-checkbox-button__inner {
    display: inline-block;
    position: relative;
    margin: 0 10px 8px 0;
}
.orderVTime{
    width: 50%;
    margin-right: 0;
  
}
.orderVTime .el-input-group{
  width: 33.33%;
}
.orderVTime .el-form-item__content{
    display: flex;
}
.orderVTime .el-input{
    border-right: 1px solid rgb(0, 0, 0, .1);
}
.orderDx .el-form-item__content{
    border: none;
}
.el-radio__input.is-checked .el-radio__inner{
    border-color:  #FF5000 !important;
    background:  #FF5000 !important;
}
.el-radio__input.is-checked+.el-radio__label{
    color: #FF5000 !important;
}
.orderSc .el-button i{
    color: #fff;
}
.orderSc .el-form-item__content{
    border: none;
}


.orderBon{
    width: calc(100% - 120px);
    position: fixed;
    right: 0;
    bottom: 0;
    background: #fff;
    border-top: 1px solid rgb(0, 0, 0, .1);
    padding: 15px 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  z-index: 99;
}
.orderBon .el-button i{
    color: #fff;
}
.orderBon .el-button:nth-child(1){
    background: #1aad19 !important
}
.orderBon .el-button:nth-child(2){
    background: #1588f5 !important
}
.el-radio__inner:hover{
    border-color: #FF5000;
}



.templateBox .el-dialog{
    width: 800px !important;
}


.templateBox .el-input__inner{
    border: 1px solid #C0C4CC !important;
}
.templateBox .el-dialog__headerbtn i{
    color: #fff;
   
}
.templateBox .el-form-item{
    width: 50%;
    margin-bottom: 0;
    margin-right: 50px;
}
.templateBox .el-form{
    display: flex;
    align-items: center;
}
.tempTable{
    margin-top: 30px
}
.tempTable .el-table th.el-table__cell{
    padding: 12px 0;
}
.tempTable .el-table th.el-table__cell {
    background: #f7f8f9 !important;
   
}
.tempTable .el-table th.el-table__cell>.cell{
    color: #333;
}
.tempTable .el-table--border{
    overflow: hidden;
}
.tempTYuan{
    width: 18px;
    height: 18px;
    border: 1px solid #DCDFE6;
    border-radius: 50%;
}
@media(max-width:1468px){

.orderFItem {
    width: 48%;
    margin-right: 2%;
}

}
@media(max-width:1368px){
    .el-checkbox-button__inner{
    font-size: 12px;
}
.el-button span {
    font-size: 12px;
}
}
</style>